import { Component, Input, OnInit } from '@angular/core';
import { ColumnMode } from '@swimlane/ngx-datatable';
import { Chart } from 'chart.js';
import * as moment from 'moment';
import { ReportsService } from '../../../../services/report.service';
import { UserService } from '../../../../services/user.service';

@Component({
  selector: 'partners-view',
  templateUrl: './partners-view.component.html',
  styleUrls: ['../../reports.component.scss', './partners-view.component.scss'],
  providers: [ReportsService, UserService]
})
export class PartnersViewComponent implements OnInit {

  @Input() places: any;

  chart;
  loggedAccount: any;
  columnModes = ColumnMode;
  lastReportDate: any;
  topPartnersRows = [];
  topCategoriesRows = [];

  categoriesIcons = {
    '59fd207f2d84ff11f8edcaf1': { iconClass: 'fa fa-pencil', bgColor: 'rgba(156, 0, 83, 0.1)', color: '#9C0053' },
    '59fd207f2d84ff11f8edcaee': { iconClass: 'fa fa-glass', bgColor: 'rgba(255, 103, 31, 0.1)', color: '#FF671F' },
    '59fd207f2d84ff11f8edcaf8': { iconClass: 'fa fa-smile-o', bgColor: 'rgba(131, 0, 70, 0.1)', color: '#830046' },
    '59fd207f2d84ff11f8edcaf2': { iconClass: 'fa fa-bicycle', bgColor: 'rgba(0, 155, 164, 0.1)', color: '#009BA4' },
    '59fd207f2d84ff11f8edcaef': { iconClass: 'fa fa-plane', bgColor: 'rgba(208, 0, 111, 0.1)', color: '#D0006F' },
    '59fd207f2d84ff11f8edcaf0': { iconClass: 'fa fa-globe', bgColor: 'rgba(208, 0, 111, 0.1)', color: '#D0006F' },
    '59fd207f2d84ff11f8edcaf3': { iconClass: 'fa fa-map-marker', bgColor: 'rgba(208, 0, 111, 0.1)', color: '#D0006F' },
    '59fd207f2d84ff11f8edcaf5': { iconClass: 'fa fa-user-md', bgColor: 'rgba(208, 0, 111, 0.1)', color: '#D0006F' },
    '59fd207f2d84ff11f8edcaf7': { iconClass: 'fa fa-heartbeat', bgColor: 'rgba(208, 0, 111, 0.1)', color: '#D0006F' },
    '59fd207f2d84ff11f8edcaf9': { iconClass: 'fa fa-handshake-o', bgColor: 'rgba(208, 0, 111, 0.1)', color: '#D0006F' }
  };

  topPartnersColumns = [
    { prop: 'position', name: '', flexGrow: 0 },
    { prop: 'company', name: '', flexGrow: 2 },
    { prop: 'views', name: 'Visualizações', flexGrow: 1 },
    { prop: 'coupons', name: 'Cupons', flexGrow: 1 }
  ];

  constructor(
    private reportService: ReportsService,
    private userService: UserService
  ) { }

  ngOnInit() {
    this.loggedAccount = this.userService.getLoggedAccount();

    if (this.places) {
      const lastPlaceReport = this.places[0];

      this.lastReportDate = moment({ month: lastPlaceReport.month - 1, year: lastPlaceReport.year }).format('MM/YY');

      this.getTopPartners(this.loggedAccount.id, lastPlaceReport.month, lastPlaceReport.year);
      this.getTopCategories(this.loggedAccount.id, lastPlaceReport.month, lastPlaceReport.year);

      setTimeout(() => this.initChart(), 200);
    }
  }

  getTopPartners(companyId, month, year) {

    this.reportService.getTopPartners(companyId, month, year).then(result => {
      this.topPartnersRows = result.map((el, index) => ({
        position: index + 1,
        company: el.establishment_name,
        views: el.views,
        coupons: el.coupons
      }));
    });
  }

  getTopCategories(companyId, month, year) {
    this.reportService.getTopCategories(companyId, month, year).then(result => {
      this.topCategoriesRows = result.slice(0, 5) || [];
    });
  }

  initChart() {
    const Months = this.places.map(el => moment({ month: el.month - 1, year: el.year }).format('MMM/YY')).reverse();
    this.chart = new Chart('partnersChart', {
      type: 'line',
      data: {
        labels: Months,
        datasets: [
          {
            backgroundColor: ['rgba(0, 155, 164, 0)'],
            borderColor: ['rgba(208, 0, 111, 1)'],
            borderWidth: 3,
            label: 'Endereços',
            data: this.places.map(el => el.totalAddresses).reverse(),
          },
          {
            backgroundColor: ['rgba(0, 155, 164, 0)'],
            borderColor: ['rgba(0, 155, 164, 1)'],
            borderWidth: 3,
            label: 'Parceiros',
            data: this.places.map(el => el.total).reverse(),
          }
        ],
      },
      options: {
        responsive: true,
        scales: {
          xAxes: [{ gridLines: { display: false, color: '#F0F0F0' } }],
          yAxes: [{ gridLines: { color: '#F0F0F0', fontFamily: 'Roboto' }, ticks: { fontFamily: 'Roboto' } }],
        }
      },
    });
  }

}
